export const getCspNonce = (): string => (document?.querySelector('meta[name="csp-nonce"]') as HTMLMetaElement)
  ?.content;
